import React, { useState, memo } from "react";
import { useSelector, useDispatch } from "react-redux";
import _ from "lodash";

import AccessCodeModal from "./AccessCodeModal";
import { trackButtonClick } from "@/utils/analytics";
// import { postSmsFlag, updateSmsWatchList } from '@/api/PDP';
// import { getUserProfile, getAllLicenseDetails } from '@/api/myProfile';

const GetAccessCode = ({ propertyData }) => {
  const userProfileData = useSelector((state) => state?.user.user);

  const [show, setShow] = useState(false);
  // const dispatch = useDispatch();
  // const [phoneNumber, setPhoneNumber]  = useState(userProfileData?.phoneNumber)
  // const [smsOptInStatus, setSMSOptInStatus]  = useState(userProfileData?.smsOptInStatus)

  const handleShow = async () => {
    setShow(true);
    trackButtonClick({
      eventName: "view_access_code",
      eventCategory: "NEW-PDP",
      eventSource: "on get code click to tour this property",
      eventLabel: `Property Id: ${propertyData?.propertyId}`,
    });
  };

  const handleClose = () => {
    setShow(false);
  };

  // const handleSubmit = (event) => {
  //     event.preventDefault();
  //     // Handle form submission
  //     handleClose();
  // };

  return (
    <div className="mb-0">
      <div className="left_side_widget pt10 pb0">
        <ol class="">
          <li class="list-group-item d-flex justify-content-between align-items-start">
            <div class="ms-2 me-auto pt10">
              <div class="pdpSubtitle2 pb10" tabIndex="0">
                Tour this property
              </div>
              <p className="pdpBody4" tabIndex="0">
                Get the access Code
              </p>
            </div>
            <div className=" pt10">
              <button
                className="btn hubzu-btn-thm"
                style={{ width: 120 }}
                type=""
                onClick={handleShow}
              >
                Get Code
              </button>
            </div>
            {/* <a href="#" class="btn btn-thm">Get Code</a> */}
          </li>
        </ol>

        <AccessCodeModal
          show={show}
          handleClose={handleClose}
          userProfileData={userProfileData}
        />
      </div>
    </div>
  );
};

export default memo(GetAccessCode);
